var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1429_2285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5.37402L8.35333 12.52C8.30696 12.5665 8.25188 12.6033 8.19125 12.6284C8.13062 12.6536 8.06563 12.6665 8 12.6665C7.93437 12.6665 7.86938 12.6536 7.80875 12.6284C7.74812 12.6033 7.69304 12.5665 7.64667 12.52L0.5 5.37402",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5.37402L8.35333 12.52C8.30696 12.5665 8.25188 12.6033 8.19125 12.6284C8.13062 12.6536 8.06563 12.6665 8 12.6665C7.93437 12.6665 7.86938 12.6536 7.80875 12.6284C7.74812 12.6033 7.69304 12.5665 7.64667 12.52L0.5 5.37402",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1429_2285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronFill);
export default __webpack_public_path__ + "static/media/chevron-fill.a81165a3b45a83e43b344855e9051429.svg";
export { ForwardRef as ReactComponent };